import { render, staticRenderFns } from "./ComponentFrame.vue?vue&type=template&id=0f5aa832&scoped=true&"
import script from "./ComponentFrame.vue?vue&type=script&lang=js&"
export * from "./ComponentFrame.vue?vue&type=script&lang=js&"
import style0 from "./ComponentFrame.vue?vue&type=style&index=0&id=0f5aa832&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5aa832",
  null
  
)

export default component.exports